import { EXPERT_PARTNER_COLORS_PALETTE } from '../constants';

interface IColorPickerField {
    label: string;
    value?: string;
    onChange: (value: string) => void;
}

const isValidHexColor = (value?: string) => {
    return /^#[0-9A-Fa-f]{6}$/.test(value || '');
};

const normalizeHexColor = (value: string) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) return '';
    const valueWithHash = trimmedValue.startsWith('#') ? trimmedValue : `#${trimmedValue}`;
    return valueWithHash.slice(0, 7).toUpperCase();
};

const ColorPickerField = ({ label, value, onChange }: IColorPickerField) => {
    const selectedColor = isValidHexColor(value) ? value || '#111827' : '#111827';

    return (
        <div className='mb-3'>
            <p className='mb-1 text-primary-light font-normal text-base'>{label}</p>
            <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
                <input
                    type='color'
                    value={selectedColor}
                    onChange={(e) => onChange(normalizeHexColor(e.target.value))}
                    className='h-10 w-14 rounded border border-borderColor dark:border-gray-700 cursor-pointer bg-white dark:bg-black'
                />
                <input
                    type='text'
                    value={value || ''}
                    onChange={(e) => onChange(normalizeHexColor(e.target.value))}
                    placeholder='#FFFFFF'
                    className='border border-borderColor rounded w-full px-3 py-2 dark:bg-black dark:text-white'
                />
                <button
                    type='button'
                    onClick={() => onChange('')}
                    className='h-10 px-3 rounded border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-900 text-sm dark:text-white'
                >
                    Clear
                </button>
            </div>
            <div className='mt-2 flex flex-wrap items-center gap-2'>
                {EXPERT_PARTNER_COLORS_PALETTE.map((color) => (
                    <button
                        type='button'
                        key={`${label}-${color}`}
                        onClick={() => onChange(color)}
                        className={`h-6 w-6 rounded-full border ${value === color ? 'ring-2 ring-offset-2 ring-black dark:ring-white dark:ring-offset-black' : 'border-gray-200 dark:border-gray-700'}`}
                        style={{ backgroundColor: color }}
                    />
                ))}
            </div>
            <span className='block h-2 mt-2' />
        </div>
    );
};

export default ColorPickerField;
